import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Select } from '@ngxs/store';
import { DxDropDownBoxComponent, DxDataGridComponent } from 'devextreme-angular';
import { Observable, Subscription } from 'rxjs';
import { TypeElementStockDto } from 'src/api/models';
import { DevExtremeTranslationService } from 'src/core/services/devExtremeTranslation.service';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-type-element-stock-select',
  templateUrl: './type-element-stock-select.component.html',
  styleUrls: ['./type-element-stock-select.component.css']
})
export class TypeElementStockSelectComponent implements OnInit {
  @ViewChild('dxDropDown') dropDown: DxDropDownBoxComponent;
  @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
  @Select(ControlPanelStore.typesElementsStock$) typesElementsStock$: Observable<TypeElementStockDto[]>;

  @Input() width: number;

  @Input() typeElementStockId: number;
  @Output() typeElementStockIdChange = new EventEmitter<number>();

  @Input() cell: any;

  InitId = null;

  TypesElementsStock: TypeElementStockDto[] = [];
  ColumnName = [];

  tes: Subscription;

  constructor(
    private translate: TranslateService,
    private devExtremeTranslationService: DevExtremeTranslationService) {
    this.devExtremeTranslationService.loadLanguage(this.translate.getBrowserLang());

    this.translate.get(
      [
        'Nom'
      ]
    ).subscribe(translations => {
      this.ColumnName.push(translations.Nom);
    });
  }

  ngOnInit() {
    if (this.typeElementStockId != null) {
      this.InitId = JSON.parse(JSON.stringify(this.typeElementStockId));
    }
    this.tes = this.typesElementsStock$.subscribe(res => {
      if (res != null) {
        this.TypesElementsStock = res;
      }
    });
  }

  ngOnDestroy() {
    this.tes?.unsubscribe();
  }

  updateInfo(event) {
    this.typeElementStockId = event.currentSelectedRowKeys.length === 1 ? event.currentSelectedRowKeys[0].Id : this.typeElementStockId;
    if (!!this.cell && this.InitId !== this.typeElementStockId) {
      this.cell.setValue(this.typeElementStockId);
    }
    this.typeElementStockIdChange.emit(this.typeElementStockId);

    if(this.typeElementStockId != null) {
      this.dropDown.instance.close();
    }
  }

  onOpened() {
    if(this.typeElementStockId == null) {
      this.dataGrid.instance.clearSelection();
    }
  }
}
